<button class="filters" mat-button (click)="changeFilter('all')" [ngClass]="{'active':filter == 'all'}">All</button>
<button class="filters" mat-button (click)="changeFilter('league_message');"
  [ngClass]="{'active':filter == 'league_message'}">Messages</button>
<button class="filters" mat-button (click)="changeFilter('pick_post');"
  [ngClass]="{'active':filter == 'pick_post'}">Picks</button>
<div class="chat" #chat [ngStyle]="{'height':getHeight(chat,input)+'px'}" (scroll)="checkMoreMessages()">
  <div class="body">
    <div class="message" *ngFor="let message of messages">
      <span class="id"
        [ngClass]="{'me':message.drafters_id == drafters_id, 'system':message.feed_type == 'system_post'}">{{ message.drafters_id }}</span>
      {{ message.detail }} {{ pickNumber(message)}}
    </div>
  </div>
</div>
<div [ngClass]="{'ban-user':!isUserAllowedToPost}" class="input" #input>
  <div class="body">
    <mat-form-field style="width:100%;">
      <input type="text" [(ngModel)]="message" matInput placeholder="Enter a message..." (keyup)="inputKey($event)">
      <button class="submit" mat-button matSuffix (click)="sendMessage()"><i class="fas fa-paper-plane"></i></button>
    </mat-form-field>
  </div>
</div>